module.exports = __webpack_public_path__ + "img/help-center.e4fec194.svg";